import React from 'react'
import MaskedInput from 'react-text-mask'
import apiCEP from '../apiCEP';

function InputCEP({ value, onChange, setCity, setAddress, setDistrict, setState }) {
    const mask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

    return (
        <>
            <label className="form-label-input">CEP</label>
            <MaskedInput name="zipcode" inputMode='numeric' mask={mask} placeholder='CEP' className="form-control" value={value} onChange={value => {
                var cep = value.target.value.replaceAll('_', '').replaceAll('-', '')

                if (cep.length === 8) {
                    apiCEP.get(cep + "/json/").then((response) => {
                        console.log(response.data);
                        setCity(response.data.localidade)
                        setAddress(response.data.logradouro)
                        setState(response.data.uf)
                        setDistrict(response.data.bairro)
                    }).catch((error) => {
                        console.error("error", error)
                    })
                }
                onChange(value.target.value)
            }}>

            </MaskedInput>
        </>
    )
}

export default InputCEP